export default __webpack_public_path__ + "static/media/G0750.Trachy_and_Lary_2.19.1667402940000.1b9de4ce.jpg";